export default __webpack_public_path__ + "static/fish-b901b03a7d5961c3622a139daef026bd.png";